import { React, useState, useEffect, useMemo } from "react";
import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import RDataGrid from "./reusables/RDataGrid";
import PageLoader from "./reusables/PageLoader";

const Roles = () => {
  const [isFetchingRoles, setIsFetchingRoles] = useState(true);
  const [roles, setRoles] = useState([]);
  const ROLES_URL = "api/v1/roles";
  const axiosPrivate = useAxiosPrivate();

  const divStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  };

  useEffect(() => {
    if (!isFetchingRoles) {
      setIsFetchingRoles(true);
    }

    let isMounted = true;
    const controller = new AbortController();

    const getRoles = async () => {
      try {
        const response = await axiosPrivate.get(ROLES_URL, {
          signal: controller.signal,
        });
        isMounted && setRoles(response.data.data);
        setIsFetchingRoles(false);
      } catch (error) {
        var errorMessage = "";
        if (error.response) {
          // The client was given an error response (5xx, 4xx)
          const errorData = error.response.data;
          errorMessage = errorData.message;
        } else if (error.request) {
          // The client never received a response, and the request was never left
          errorMessage = "No server response";
        } else {
          // Anything else
          errorMessage = "Unexpected error occurred";
        }
        console.log(errorMessage);
        setIsFetchingRoles(false);
      }
    };

    getRoles();

    return () => {
      isMounted = false;
      controller.abort();
    };

    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  const columns = useMemo(
    () => [
      {
        field: "id",
        headerName: "Id",
        width: 60,
        align: "center",
        headerAlign: "center",
      },
      {
        field: "name",
        headerName: "Name",
        width: 200,
        align: "center",
        headerAlign: "center",
      },
    ],
    []
  );

  return isFetchingRoles ? (
    <PageLoader title="Loading roles..." />
  ) : (
    <Box
      sx={{
        height: "100%",
        width: "100%",
      }}
    >
      <Box height={40} />

      {roles?.length ? (
        <Box
          sx={{
            height: 560,
            width: "100%",
          }}
        >
          <div style={divStyle}>
            <Typography
              variant="h4"
              component="h4"
              sx={{ textAlign: "left", mt: 3, mb: 3 }}
            >
              User Roles
            </Typography>
          </div>
          <Box sx={{ width: 300, height: 400 }}>
            <RDataGrid columns={columns} rows={roles} rowHeight={63} />
          </Box>
        </Box>
      ) : (
        <div style={divStyle}>
          <Typography
            variant="h4"
            component="h4"
            sx={{ textAlign: "center", mt: 3, mb: 3 }}
          >
            No roles to display
          </Typography>
        </div>
      )}
    </Box>
  );
};

export default Roles;
